import { EditorChangeType } from '../types';

import type { Element } from '../models/Element';
import type { VideoEditor } from '../VideoEditor';
import type { Command } from './Command';

export class MoveElementToTrackCommand implements Command {
  private editor: VideoEditor;
  private elementId: string;
  private targetTrackId: string;
  private sourceTrackId?: string;
  private element?: Element;
  private executed: boolean = false;

  getName(): string {
    return 'MoveElementToTrackCommand';
  }

  shouldCreateUndoRedoEntry(): boolean {
    return true;
  }

  constructor(editor: VideoEditor, elementId: string, targetTrackId: string) {
    this.editor = editor;
    this.elementId = elementId;
    this.targetTrackId = targetTrackId;
    this.element = this.editor.getElementById(elementId);
    this.sourceTrackId = this.editor.timeline.getTrackIdForElement(elementId);
  }

  execute(): boolean {
    if (!this.element || !this.sourceTrackId) return false;

    const success = this.editor.timeline.moveElementToTrack(
      this.elementId,
      this.targetTrackId,
    );
    if (success) {
      this.executed = true;
      this.editor.markDirty('move_element_to_track_command');
      this.editor.notifyObservers(EditorChangeType.ELEMENT_SHIFTED, {
        elementId: this.elementId,
        element: this.element,
        sourceTrackId: this.sourceTrackId,
        targetTrackId: this.targetTrackId,
      });
    }
    return success;
  }

  undo(): boolean {
    if (!this.executed || !this.element || !this.sourceTrackId) return false;

    const success = this.editor.timeline.moveElementToTrack(
      this.elementId,
      this.sourceTrackId,
    );
    if (success) {
      this.executed = false;
      this.editor.markDirty('move_element_to_track_command_undo');
      this.editor.notifyObservers(EditorChangeType.ELEMENT_SHIFTED, {
        elementId: this.elementId,
        element: this.element,
        sourceTrackId: this.targetTrackId,
        targetTrackId: this.sourceTrackId,
      });
    }
    return success;
  }

  redo(): boolean {
    if (this.executed) return false;
    return this.execute();
  }

  getDescription(): string {
    return `Move element ${this.elementId} from track ${this.sourceTrackId} to track ${this.targetTrackId}`;
  }
}
